export default {"src":"/_next/static/media/dashboard-active-icon.a47beea1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};